import { DataBean } from "../DataBean";

export class WelfarePaymentByIncapacity extends DataBean {



    public async getIncapacityWelfarePaymentByIncapacity(idDocument:any,documentDate:any,noveltyID:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getIncapacityWelfarePaymentByIncapacity_Number_java.util.Date_Number", [idDocument,documentDate,noveltyID]);
    }
    public async updateIncapacityWelfarePayment(bean:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.employees.IncapacityWelfarePayment_updateIncapacityWelfarePayment_com.quickdataerp.bean.employees.IncapacityWelfarePayment", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.employees.IncapacityWelfarePayment"
            }
        ]);
    }
    
    public async deleteIncapacityWelfarePayments(idIncapacityWelfarePayment:any,idDocument:any,documentDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_deleteIncapacityWelfarePayments_Number_Number_java.util.Date", [idIncapacityWelfarePayment,idDocument,documentDate]);
    }
}